<template>
  <div
    :style="`min-height:${minHeight}px;`"
    class="table-responsive base-table table-soft"
    :class="{ 'b-table-sticky-header': sticky }"
  >
    <table
      class="table tablesorter b-table b-table-no-border-collapse b-table-selectable b-table-selecting"
      :class="tableClass"
    >
      <thead :class="theadClasses">
        <tr>
          <slot name="columns" :columns="columns">
            <th v-for="column in columns" :key="column">{{ column }}</th>
          </slot>
        </tr>
      </thead>
      <tbody :class="tbodyClasses">
        <slot name="bodys"></slot>
        <template v-for="(item, index) in data">
          <slot :row="item" :item="item" :index="index">
            <td v-for="(column, index) in colsWithValue(item)" :key="index">
              {{ itemValue(item, column) }}
            </td>
          </slot>
        </template>
      </tbody>
      <tfoot>
        <slot name="tfoot"></slot>
      </tfoot>
    </table>
    <slot name="footer"></slot>
  </div>
</template>
<script>
// import Velocity from "velocity";
export default {
  name: "base-table",
  props: {
    sticky: {
      type: Boolean,
      default: true
    },
    minHeight: {
      type: Number, // striped | hover
      default: 150,
      description: "Min Height Table . Unit = px"
    },
    columns: {
      type: Array,
      default: () => [],
      description: "Table columns"
    },
    data: {
      type: Array,
      default: () => [],
      description: "Table data"
    },
    type: {
      type: String, // striped | hover
      default: "",
      description: "Whether table is striped or hover type"
    },
    theadClasses: {
      type: String,
      default: "",
      description: "<thead> css classes"
    },
    tbodyClasses: {
      type: String,
      default: "",
      description: "<tbody> css classes"
    }
  },
  computed: {
    tableClass() {
      return this.type && `table-${this.type}`;
    },
    colsWithValue() {
      return row => {
        return this.columns.filter(column => this.hasValue(row, column));
      };
    }
  },
  methods: {
    hasValue(item, column) {
      return item[column.toLowerCase()] !== "undefined";
    },
    itemValue(item, column) {
      return item[column.toLowerCase()];
    }
  }
};
</script>
<style lang="scss">
.base-table {
  thead {
    th {
      background-position: right calc(0.75rem / 2) center;
      padding-right: calc(0.75rem + 0.65em);
    }
  }
}
</style>
